export default __webpack_public_path__ + "static/Greycliffcf-light-webfont-043f0b76a47af05c3112bb19e819f0ab.woff";